import Component from '../abstracts/Component';

export default class MyAccountLayerComponent extends Component {
  get SELECTORS() {
    return {
      headerMyAccountUserLoggedAttribute: 'data-user-logged-in',
      headerMyAccountLayer: '[data-header-my-account-layer]',
      headerMyAccountButton: '[data-header-my-account-button]',
      menuMyAccountButton: '[data-menu-my-account-button]',
      headerMyAccountCloseLayerButton: '[data-close-header-my-account-layer]',
      headerMyAccountPasswordRecoveryButton:
        '[data-header-password-recovery-button]',
      headerMyAccountPasswordRecoveryStep: '[data-header-my-account-step]',
      headerMyAccountPasswordRecoveryStepNameAttribute:
        'data-header-my-account-step-name',
      closeHeaderMyAccountStep: '[data-close-header-my-account-step]',
      closeHeaderMyAccountStepTargetAttribute:
        'data-close-header-my-account-step-target',
      closeHeaderMyAccountStepPreviousAttribute:
        'data-close-header-my-account-step-previous',
      headerMyAccountPasswordRecoveryForm: '[data-password-recovery-form]',
      headerMyAccountPasswordRecoveryResultTitle:
        '[data-header-my-account-result-step-title]',
      headerMyAccountPasswordRecoveryResultContent:
        '[data-header-my-account-result-step-content]',
      headerMyAccountPasswordRecoveryResultSuccessSelector:
        'data-success-value',
      headerMyAccountPasswordResetAllStepsSelector:
        'data-reset-header-my-account-steps',
      headerMyAccountPasswordResetEmailField:
        '[data-password-recovery-email-field]',
      headerMyAccountPasswordResetErrorMessage:
        '[data-password-recovery-error-message]',
      loginPopup: '[data-login-popup].--show',
      benefitBar: '[data-benefit-bar]',
    };
  }

  get CLASSES() {
    return {
      headerMyAccountLayerOpen: '--open',
      headerMyAccountActionLayerOpen: '--open-layer',
      headerMyAccountLayerHiddenStep: '--hidden-step',
      headerMyAccountLayerCurrentStep: '--current-step',
      headerMyAccountLayerDisabledStep: '--disabled-step',
      headerMyAccountPerformingAction: '--performing-action',
      headerMyAccountPasswordRecoveryFieldError: 'error',
      headerMyAccountPasswordRecoveryLabelError: '--visible',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.currentViewport = null;
    this.userIsLogged =
      this.$component.getAttribute(
        this.SELECTORS.headerMyAccountUserLoggedAttribute
      ) === 'true';
    this.dom = {
      headerMyAccountLayer: this.$component.querySelector(
        this.SELECTORS.headerMyAccountLayer
      ),
      headerMyAccountButton: this.$component.querySelector(
        this.SELECTORS.headerMyAccountButton
      ),
      menuMyAccountButton: document.querySelector(
        this.SELECTORS.menuMyAccountButton
      ),
      headerMyAccountCloseLayerButton: this.$component.querySelector(
        this.SELECTORS.headerMyAccountCloseLayerButton
      ),
      headerMyAccountPasswordRecoveryButton: this.$component.querySelector(
        this.SELECTORS.headerMyAccountPasswordRecoveryButton
      ),
      headerMyAccountPasswordRecoveryForm: this.$component.querySelector(
        this.SELECTORS.headerMyAccountPasswordRecoveryForm
      ),
      headerMyAccountPasswordRecoveryResultTitle: this.$component.querySelector(
        this.SELECTORS.headerMyAccountPasswordRecoveryResultTitle
      ),
      headerMyAccountPasswordRecoveryResultContent:
        this.$component.querySelector(
          this.SELECTORS.headerMyAccountPasswordRecoveryResultContent
        ),
      headerMyAccountPasswordRecoverySteps: this.$component.querySelectorAll(
        this.SELECTORS.headerMyAccountPasswordRecoveryStep
      ),
      closeHeaderMyAccountStepButtons: this.$component.querySelectorAll(
        this.SELECTORS.closeHeaderMyAccountStep
      ),
      headerMyAccountPasswordResetEmailField: this.$component.querySelector(
        this.SELECTORS.headerMyAccountPasswordResetEmailField
      ),
      headerMyAccountPasswordResetErrorMessage: this.$component.querySelector(
        this.SELECTORS.headerMyAccountPasswordResetErrorMessage
      ),
    };
  }

  findCurrentStepElement() {
    const nodeListTarget = this.dom.headerMyAccountPasswordRecoverySteps;
    let currentStep = null;
    for (let i = 0; i < nodeListTarget.length; i++) {
      const currentStepLoop = nodeListTarget[i];
      if (
        currentStepLoop.classList.contains(
          this.CLASSES.headerMyAccountLayerCurrentStep
        )
      ) {
        currentStep = currentStepLoop;
        break;
      }
    }
    return currentStep;
  }

  applyBlockCurrentPasswordRecoveryStep(block = false) {
    const currentStep = this.findCurrentStepElement();

    if (currentStep)
      if (block === true)
        currentStep.classList.add(this.CLASSES.headerMyAccountPerformingAction);
      else
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountPerformingAction
        );
  }

  applyCurrentStepDesktopHeight() {
    const currentStep = this.findCurrentStepElement();
    if (currentStep) {
      this.dom.headerMyAccountLayer.style.height = `${currentStep.offsetHeight}px`;
    }
  }

  activatePasswordRecoveryStep(step) {
    let heightCurrentStep = 0;
    this.dom.headerMyAccountPasswordRecoverySteps.forEach((currentStep) => {
      const currentStepName = currentStep.getAttribute(
        this.SELECTORS.headerMyAccountPasswordRecoveryStepNameAttribute
      );

      if (currentStepName === step) {
        heightCurrentStep = currentStep.offsetHeight;
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountLayerHiddenStep,
          this.CLASSES.headerMyAccountLayerDisabledStep
        );
        currentStep.classList.add(this.CLASSES.headerMyAccountLayerCurrentStep);
      } else {
        currentStep.classList.add(
          this.CLASSES.headerMyAccountLayerDisabledStep
        );
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountLayerCurrentStep
        );
      }
      /**
       * Remove the password recovery errors if the step is reset
       */
      if (currentStepName === 'reset') {
        this.dom.headerMyAccountPasswordResetEmailField.classList.remove(
          this.CLASSES.headerMyAccountPasswordRecoveryFieldError
        );
        this.dom.headerMyAccountPasswordResetErrorMessage.classList.remove(
          this.CLASSES.headerMyAccountPasswordRecoveryLabelError
        );
      }
      /**
       * Remove the performing action CSS class if exists
       */
      if (
        currentStep.classList.contains(
          this.CLASSES.headerMyAccountPerformingAction
        )
      )
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountPerformingAction
        );
    });
    if (this.currentViewport === 'desktop' && heightCurrentStep > 0)
      this.dom.headerMyAccountLayer.style.height = `${heightCurrentStep}px`;
  }

  deactivatePasswordRecoveryStep(step, previous) {
    let heightCurrentStep = 0;
    this.dom.headerMyAccountPasswordRecoverySteps.forEach((currentStep) => {
      const currentStepName = currentStep.getAttribute(
        this.SELECTORS.headerMyAccountPasswordRecoveryStepNameAttribute
      );
      if (currentStepName === step) {
        currentStep.classList.add(
          this.CLASSES.headerMyAccountLayerHiddenStep,
          this.CLASSES.headerMyAccountLayerDisabledStep
        );
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountLayerCurrentStep
        );
      } else if (currentStepName === previous) {
        heightCurrentStep = currentStep.offsetHeight;
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountLayerDisabledStep
        );
        currentStep.classList.add(this.CLASSES.headerMyAccountLayerCurrentStep);
      }
    });
    if (this.currentViewport === 'desktop' && heightCurrentStep > 0)
      this.dom.headerMyAccountLayer.style.height = `${heightCurrentStep}px`;
  }

  deactivateAllPasswordRecoverySteps() {
    let heightLoginStep = 0;
    if (!this.userIsLogged) {
      this.dom.headerMyAccountPasswordRecoverySteps.forEach((currentStep) => {
        const currentStepName = currentStep.getAttribute(
          this.SELECTORS.headerMyAccountPasswordRecoveryStepNameAttribute
        );
        if (currentStepName !== 'login') {
          currentStep.classList.add(
            this.CLASSES.headerMyAccountLayerHiddenStep,
            this.CLASSES.headerMyAccountLayerDisabledStep
          );
          currentStep.classList.remove(
            this.CLASSES.headerMyAccountLayerCurrentStep
          );
        } else {
          heightLoginStep = currentStep.offsetHeight;
          currentStep.classList.remove(
            this.CLASSES.headerMyAccountLayerDisabledStep
          );
          currentStep.classList.add(
            this.CLASSES.headerMyAccountLayerCurrentStep
          );
        }
        currentStep.classList.remove(
          this.CLASSES.headerMyAccountPerformingAction
        );
        this.dom.headerMyAccountPasswordResetEmailField.classList.remove(
          this.CLASSES.headerMyAccountPasswordRecoveryFieldError
        );
        this.dom.headerMyAccountPasswordResetErrorMessage.classList.remove(
          this.CLASSES.headerMyAccountPasswordRecoveryLabelError
        );
      });
      if (this.currentViewport === 'desktop' && heightLoginStep > 0) {
        this.dom.headerMyAccountLayer.style.height = `${heightLoginStep}px`;
      }
    } else {
      if (this.currentViewport === 'desktop') {
        this.dom.headerMyAccountLayer.style.height = 'auto';
      }
    }
  }

  /**
   * Detect the current viewport, and return a string indicating whether it's
   * either 'mobile' or 'desktop'. The viewport is determined by the window's
   * innerWidth property.
   *
   * @returns {string} a string indicating the current viewport, either 'mobile',
   * 'tablet' or 'desktop'.
   */
  calculateCurrentViewport() {
    const viewportWidth = window.innerWidth;
    let currentViewport = 'mobile';
    if (viewportWidth >= 768 && viewportWidth < 1440) {
      currentViewport = 'tablet';
    } else if (viewportWidth >= 1440) {
      currentViewport = 'desktop';
    }

    return currentViewport;
  }

  calculateResize() {
    const newViewport = this.calculateCurrentViewport();
    if (this.currentViewport !== newViewport) {
      if (newViewport !== 'desktop') {
        this.dom.headerMyAccountLayer.style.height = '100vh';
      } else {
        this.dom.headerMyAccountLayer.style.height = 'auto';
        if (
          this.dom.headerMyAccountLayer.classList.contains(
            this.CLASSES.headerMyAccountLayerOpen
          )
        ) {
          this.dom.headerMyAccountLayer.classList.remove(
            this.CLASSES.headerMyAccountLayerOpen
          );
        }
      }
      this.deactivateAllPasswordRecoverySteps();
    }
    this.currentViewport = newViewport;
  }

  /**
   * Hides the action layer after 3 seconds of inactivity by removing the
   * '--open-layer' class from the component's root element.
   */
  hideLayerDesktopByTimeOut(success = false) {
    if (this.currentViewport === 'desktop') {
      setTimeout(() => {
        this.$component.classList.remove(
          this.CLASSES.headerMyAccountActionLayerOpen
        );
        if (success) {
          this.deactivateAllPasswordRecoverySteps();
        }
      }, 3000);
    }
  }

  bindEvents() {
    /**
     * Detect the current viewport first time and add a
     * resize event listener
     */
    this.calculateResize();
    window.addEventListener('resize', () => {
      this.calculateResize();
    });

    /**
     * Check if profile button menu exists and add a click event listener
     * for non desktop viewport to show the account layer
     */
    if (this.dom.menuMyAccountButton) {
      this.dom.menuMyAccountButton.addEventListener('click', () => {
        if (this.currentViewport !== 'desktop') {
          if (
            this.dom.headerMyAccountLayer &&
            !this.dom.headerMyAccountLayer.classList.contains(
              this.CLASSES.headerMyAccountLayerOpen
            )
          ) {
            this.dom.headerMyAccountLayer.classList.add(
              this.CLASSES.headerMyAccountLayerOpen
            );
            // TODO: emit an event to lock menu actions with a CSS class
          }
        }
      });
    }

    /**
     * Bind the account layer event when mouse enter in desktop
     */
    this.$component.addEventListener('mouseenter', () => {
      if (this.currentViewport === 'desktop') {
        this.applyCurrentStepDesktopHeight();
      }
    });

    /**
     * Bind the account layer events for non logged user only
     */
    if (!this.userIsLogged) {
      /**
       * Bind the account layer close button
       */
      this.dom.headerMyAccountCloseLayerButton.addEventListener('click', () => {
        if (
          this.dom.headerMyAccountLayer &&
          this.dom.headerMyAccountLayer.classList.contains(
            this.CLASSES.headerMyAccountLayerOpen
          )
        ) {
          this.dom.headerMyAccountLayer.classList.remove(
            this.CLASSES.headerMyAccountLayerOpen
          );
          if (!this.userIsLogged) this.deactivateAllPasswordRecoverySteps();
        }
      });

      /**
       * Bind the close current layer step to all buttons
       */
      this.dom.closeHeaderMyAccountStepButtons.forEach(
        (currentCloseStepButton) => {
          const currentCloseResetAllSteps = currentCloseStepButton.getAttribute(
            this.SELECTORS.headerMyAccountPasswordResetAllStepsSelector
          );
          currentCloseStepButton.addEventListener('click', () => {
            const currentStepName = currentCloseStepButton.getAttribute(
              this.SELECTORS.closeHeaderMyAccountStepTargetAttribute
            );
            const previousStepName = currentCloseStepButton.getAttribute(
              this.SELECTORS.closeHeaderMyAccountStepPreviousAttribute
            );
            if (currentCloseResetAllSteps)
              this.deactivateAllPasswordRecoverySteps();
            else if (currentStepName && previousStepName)
              this.deactivatePasswordRecoveryStep(
                currentStepName,
                previousStepName
              );
          });
        }
      );

      /**
       * Bind the password recovery form submit button to fetch
       * an asynchronous call
       */
      if (this.dom.headerMyAccountPasswordRecoveryForm)
        this.dom.headerMyAccountPasswordRecoveryForm.addEventListener(
          'submit',
          async (event) => {
            event.preventDefault();
            try {
              let callSuccess = false;
              if (this.currentViewport === 'desktop') {
                this.$component.classList.add(
                  this.CLASSES.headerMyAccountActionLayerOpen
                );
              }
              const passwordRecoveryUrl =
                this.dom.headerMyAccountPasswordRecoveryForm.action;
              const formData = new FormData(event.target);
              this.dom.headerMyAccountPasswordResetEmailField.classList.remove(
                this.CLASSES.headerMyAccountPasswordRecoveryFieldError
              );
              this.dom.headerMyAccountPasswordResetErrorMessage.classList.remove(
                this.CLASSES.headerMyAccountPasswordRecoveryLabelError
              );
              this.applyBlockCurrentPasswordRecoveryStep(true);
              this.applyCurrentStepDesktopHeight();
              await fetch(passwordRecoveryUrl, {
                method: 'POST',
                body: formData,
              })
                .then((response) => {
                  if (response.status === 200 && response.ok === true) {
                    const titleContent =
                      this.dom.headerMyAccountPasswordRecoveryResultTitle.getAttribute(
                        this.SELECTORS
                          .headerMyAccountPasswordRecoveryResultSuccessSelector
                      );
                    const textContent =
                      this.dom.headerMyAccountPasswordRecoveryResultContent.getAttribute(
                        this.SELECTORS
                          .headerMyAccountPasswordRecoveryResultSuccessSelector
                      );
                    this.dom.headerMyAccountPasswordRecoveryResultTitle.innerHTML =
                      titleContent;
                    this.dom.headerMyAccountPasswordRecoveryResultContent.innerHTML = `${textContent} ${formData.get('email')}`;
                    callSuccess = true;
                    this.dom.headerMyAccountPasswordRecoveryForm.reset();
                    this.activatePasswordRecoveryStep('result');
                  } else {
                    this.dom.headerMyAccountPasswordResetEmailField.classList.add(
                      this.CLASSES.headerMyAccountPasswordRecoveryFieldError
                    );
                    this.dom.headerMyAccountPasswordResetErrorMessage.classList.add(
                      this.CLASSES.headerMyAccountPasswordRecoveryLabelError
                    );
                    this.applyBlockCurrentPasswordRecoveryStep();
                  }
                })
                .catch((error) => {
                  console.warn(error);
                  this.applyBlockCurrentPasswordRecoveryStep();
                })
                .finally(() => {
                  this.hideLayerDesktopByTimeOut(callSuccess);
                });
            } catch (error) {
              console.error(
                'Error on fetch password recovery from header my account layout!'
              );
              console.error(error);
              this.hideLayerDesktopByTimeOut();
            }
          }
        );

      /**
       * Bind the password recovery button click event
       */
      this.dom.headerMyAccountPasswordRecoveryButton.addEventListener(
        'click',
        () => {
          this.dom.headerMyAccountPasswordRecoveryForm.reset();
          this.dom.headerMyAccountPasswordResetEmailField.classList.remove(
            this.CLASSES.headerMyAccountPasswordRecoveryFieldError
          );
          this.dom.headerMyAccountPasswordResetErrorMessage.classList.remove(
            this.CLASSES.headerMyAccountPasswordRecoveryLabelError
          );
          this.activatePasswordRecoveryStep('reset');
        }
      );
    }
    this.handleLoginErrorOnLoad();

    document.addEventListener('click', (event) => {
      if (this.$component.classList.contains(this.CLASSES.headerMyAccountActionLayerOpen) && !this.$component.contains(event.target)) {
        this.$component.classList.remove(this.CLASSES.headerMyAccountActionLayerOpen);
      }
    });
  }

  handleLoginErrorOnLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasLoginError = urlParams.get('loginerror') === 'true';
    const isLoginPopupActive = document.querySelector(this.SELECTORS.loginPopup);
    if (hasLoginError && !this.userIsLogged && !isLoginPopupActive) {
      if (this.currentViewport === 'desktop') {
        this.$component.classList.add(this.CLASSES.headerMyAccountActionLayerOpen);
        this.applyCurrentStepDesktopHeight();
      }
      else {
        const benefitBar = document.querySelector(this.SELECTORS.benefitBar);
        if (benefitBar) {
          benefitBar.classList.add('--hide');
        }
        this.dom.headerMyAccountLayer.classList.add(this.CLASSES.headerMyAccountLayerOpen);
      }
    }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
